import { IRoute, RouterItemPg, TokenService } from 'viggo-sistemas-core-web';
// eslint-disable-next-line import/no-cycle
import {
  filterGrantMenuItens,
  filterGrantSubMenuItens,
  ordemAlfabetica,
  ordemPrecendecia
} from '../menu.service';

export class MenuAdmin {
  constructor(protected tokenService: TokenService) {}

  /**
   * Menu de cadastros (participantes e expedição)
   * @param routes
   * @returns
   */
  createMenuCadastros(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantSubMenuItens(routes, [
      {
        menuItem: {
          icon: 'mdi mdi-handshake-outline',
          label: 'Participantes',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-participantes',
          items: [
            {
              icon: 'mdi mdi-account',
              isSubMenu: false,
              label: 'Clientes',
              routerLink: ['/clientes'],
              idElement: 'menu-parceiro-cliente',
              backend_config: [
                {
                  url: '/clientes',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Fornecedores',
              isSubMenu: false,
              icon: 'mdi mdi-domain',
              routerLink: ['/fornecedores'],
              idElement: 'menu-parceiro-fornecedor',
              backend_config: [
                {
                  url: '/fornecedores',
                  method: 'POST'
                }
              ],
              precedence: 2
            },
            {
              label: 'Fabricantes',
              isSubMenu: false,
              icon: 'mdi mdi-office-building',
              idElement: 'menu-parceiro-fabricante',
              routerLink: ['/fabricantes'],
              backend_config: [
                {
                  url: '/fabricantes',
                  method: 'GET'
                }
              ],
              precedence: 3
            },
            {
              label: 'Funcionário',
              isSubMenu: false,
              routerLink: ['/funcionarios'],
              icon: 'mdi mdi-account-supervisor-circle-outline',
              idElement: 'menu-parceiro-funcionarios',
              backend_config: [
                {
                  url: '/funcionarios',
                  method: 'POST'
                }
              ],
              precedence: 4
            },
            {
              label: 'Vendedor',
              isSubMenu: false,
              routerLink: ['/vendedores'],
              icon: 'mdi mdi-account-multiple-outline',
              idElement: 'menu-parceiro-vendedor',
              backend_config: [
                {
                  url: '/vendedores/<id>/clientes',
                  method: 'GET'
                }
              ],
              precedence: 5
            }
          ]
        },
        matchBackendRoutes: [
          {
            url: '/clientes',
            method: 'POST'
          },
          {
            url: '/fornecedores',
            method: 'POST'
          },
          {
            url: '/fabricantes',
            method: 'GET'
          },
          {
            url: '/funcionarios',
            method: 'POST'
          },
          {
            url: '/vendedores/<id>/clientes',
            method: 'GET'
          }
        ]
      }
    ]);
    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Cadastros',
        icon: 'mdi mdi-plus-box-multiple-outline',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        idElement: 'menu-cadastros'
      };

    return menu;
  }

  /*
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createMateriaPrimaMenu(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Categoria de matérias primas',
          routerLink: ['/categoria_materia_primas'],
          icon: 'mdi mdi-shape-outline',
          idElement: 'menu-categoria-materia-prima',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/categoria_materia_primas'
          }
        ]
      },
      {
        menuItem: {
          label: 'Matéria Prima',
          routerLink: ['/materia_prima'],
          icon: 'mdi mdi-shape-outline',
          idElement: 'menu-materia',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/materia_primas'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada',
          routerLink: ['/entrada_materiais'],
          icon: 'mdi mdi-archive-arrow-up-outline',
          idElement: 'menu-entrada',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/rees'
          }
        ]
      },
      {
        menuItem: {
          label: 'Saida',
          routerLink: ['/saida_materiais'],
          icon: 'mdi mdi-archive-arrow-down-outline',
          idElement: 'menu-saida',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/rses'
          }
        ]
      },
      {
        menuItem: {
          label: 'Transformação de matéria',
          routerLink: ['/conversao_materia_prima'],
          icon: 'mdi mdi-swap-horizontal',
          idElement: 'menu-conversao-materia-prima',
          precedence: 5
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/tmps'
          }
        ]
      },
      {
        menuItem: {
          label: 'Ajuste de estoque',
          routerLink: ['/ajuste_estoque'],
          icon: 'mdi mdi-archive-edit-outline',
          idElement: 'menu-ajuste-estoque',
          precedence: 6
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/ajuste_materias'
          }
        ]
      },
      {
        menuItem: {
          label: 'Variações matéria prima',
          isSubMenu: false,
          routerLink: ['/variacao_materia_prima'],
          icon: 'mdi mdi-vector-difference-ba',
          idElement: 'menu-variacoes-materia',
          precedence: 7
        },
        matchBackendRoutes: [
          {
            url: '/variacao_materias',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Grade de matéria prima',
          isSubMenu: false,
          routerLink: ['/materia_prima_variacoes'],
          icon: 'mdi mdi-sitemap',
          idElement: 'menu-materia-prima-grade',
          precedence: 8
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/materia_prima_variacoes'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Matéria prima',
        icon: 'mdi mdi-shape-outline',
        routerLink: null,
        items: submenu,
        idElement: 'menu-principal-materia-prima'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createProdutoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Categorias do produto',
          routerLink: ['/categoria_produtos'],
          idElement: 'menu-produto-categoria',
          icon: 'mdi mdi-shape-outline',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/categoria_produtos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Tabela de preços',
          routerLink: ['/tabela_preco'],
          idElement: 'menu-tabela-preco',
          icon: 'mdi mdi-file-table-box-multiple-outline',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/tabela_precos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Produtos',
          isSubMenu: false,
          routerLink: ['/produtos'],
          icon: 'pi pi-fw pi-box',
          idElement: 'menu-produto',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/produtos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada',
          routerLink: ['/entrada_produtos'],
          icon: 'mdi mdi-archive-arrow-up-outline',
          idElement: 'menu-entrada',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/ree_produtos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Saida',
          routerLink: ['/saida_produtos'],
          icon: 'mdi mdi-archive-arrow-down-outline',
          idElement: 'menu-saida',
          precedence: 5
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/rse_produtos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada de produtos via pedido',
          routerLink: ['/entrada_via_pedidos'],
          icon: 'mdi mdi-swap-horizontal',
          idElement: 'menu-entrada-via-pedido',
          precedence: 6
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/tpe_produtos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Variações produto',
          isSubMenu: false,
          routerLink: ['/variacao_produtos'],
          icon: 'mdi mdi-vector-difference-ba',
          idElement: 'menu-variacoes',
          precedence: 7
        },
        matchBackendRoutes: [
          {
            url: '/variacoes',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Grade de produtos',
          isSubMenu: false,
          routerLink: ['/produto_variacoes'],
          icon: 'mdi mdi-sitemap',
          idElement: 'menu-produto-grade',
          precedence: 8
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/produto_variacoes'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        icon: 'pi pi-fw pi-box',
        label: 'Produto acabado',
        routerLink: null,
        items: submenu,
        idElement: 'menu-produto-acabado'
      };

    return menu;
  }

  /**
   * Gera o menu de produção de pedidos
   * @param routes
   */
  createMenuPedidosProducao(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Pedidos',
          routerLink: ['/pedidos'],
          icon: 'pi pi-fw pi-shopping-cart',
          idElement: 'menu-pedidos',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pedidos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Monitoramento dos pedidos em produção',
          routerLink: ['/observar/pedidos_monitoramento'],
          icon: 'mdi mdi-table-eye',
          idElement: 'menu-monitoramento',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pedidos/monitoramento'
          }
        ]
      },
      {
        menuItem: {
          label: 'Gerenciamento dos pedidos em produção',
          routerLink: ['/observar/pedidos_gerenciamento'],
          icon: 'mdi mdi-progress-wrench',
          idElement: 'menu-gerenciamento',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'DELETE',
            url: '/pedidos/<id>'
          }
        ]
      },
      {
        menuItem: {
          label: 'Histórico do pedido',
          routerLink: ['/info_pedidos'],
          icon: 'pi pi-fw pi-history',
          idElement: 'menu-historico-pedidos',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pedidos/<id>/historico_detalhes'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Produção de pedidos',
        icon: 'mdi mdi-hammer-wrench',
        routerLink: null,
        items: submenu,
        idElement: 'menu-principal-pedidos-producao'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de relatórios
   * @param routes Rotas permitidas ao usuário
   */
  createMenuReport(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Por estoque de materiais',
          routerLink: ['/relatorio/estoque_materiais'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-estoque-materiais'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/materia_primas/relatorio_estoque_pdf'
          },
          {
            method: 'GET',
            url: '/materia_primas/relatorio_estoque_xlsx'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por estoque de produtos',
          routerLink: ['/relatorio/estoque_produtos'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-estoque-produtos'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/produtos/relatorio_estoque_pdf'
          },
          {
            method: 'GET',
            url: '/produtos/relatorio_estoque_xlsx'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por entradas e saídas financeiras',
          routerLink: ['/relatorio/entrada_saida'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-report-entrada-saida'
        },
        matchBackendRoutes: [
          {
            url: '/movimentacao_financeiras',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por vendas',
          routerLink: ['/relatorio/vendas'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-report-vendas'
        },
        matchBackendRoutes: [
          {
            url: '/vendas',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por consumo de materiais',
          routerLink: ['/relatorio/consumo_materiais'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-consumo-materiais'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pedidos/relatorio_consumo_geral_pdf'
          },
          {
            method: 'POST',
            url: '/pedidos/relatorio_consumo_geral_xlsx'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por totais de custos',
          routerLink: ['/relatorio/total_custos'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-total-custos'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pedido_lotes'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por participantes',
          routerLink: ['/relatorio/final_participantes'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-final-participantes'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/historico_movimentacoes/saldo_dos_participantes_pdf'
          },
          {
            method: 'POST',
            url: '/historico_movimentacoes/saldo_dos_participantes_xlsx'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por ações em produção de peças',
          routerLink: ['/relatorio/acoes_producao'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-report-acoes-producao'
        },
        matchBackendRoutes: [
          {
            url: '/relatorios/acoes_producao',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por Kardex de estoque',
          routerLink: ['/relatorio/kardex'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-kardex'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/materia_primas/kardex'
          },
          {
            method: 'POST',
            url: '/materia_primas/<id>/kardex'
          },
          {
            method: 'POST',
            url: '/produtos/<id>/kardex'
          },
          {
            method: 'POST',
            url: '/produtos/kardex'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por status do gerenciamento',
          routerLink: ['/relatorio/status_gerenciamento'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-relatorio-status-gerenciamento'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pedidos/relatorio_status_gerenciamento_pdf'
          },
          {
            method: 'POST',
            url: '/pedidos/relatorio_status_gerenciamento_xlsx'
          }
        ]
      },
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Relatórios',
        icon: 'pi pi-fw pi-print',
        routerLink: null,
        items: submenu,
        idElement: 'menu-relatorio'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de relatórios
   * @param routes Rotas permitidas ao usuário
   */
  createMenuConfiguracoes(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];
    var subMenuBuild = [
      {
        menuItem: {
          label: 'Financeiro',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-currency-brl',
          items: [
            {
              label: 'Formas de Pagamento',
              isSubMenu: false,
              routerLink: ['/formas-pagamento'],
              idElement: 'menu-forma-pagto',
              icon: 'mdi mdi-credit-card-outline',
              backend_config: [
                {
                  url: '/forma_pagamentos',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Condição de Pagamento',
              isSubMenu: false,
              routerLink: ['/condicao-pagamento'],
              idElement: 'menu-cond-pagto',
              icon: 'mdi mdi-cash-multiple',
              backend_config: [
                {
                  url: '/condicao_pagamentos',
                  method: 'POST'
                }
              ],
              precedence: 2
            },
            {
              label: 'Portadores',
              isSubMenu: false,
              routerLink: ['/portadores'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-portador',
              backend_config: [
                {
                  url: '/portadores/<id>/ajuste_saldo',
                  method: 'PUT'
                }
              ],
              precedence: 3
            },
            {
              label: 'Natureza financeiras',
              isSubMenu: false,
              routerLink: ['/natureza_financeiras'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-natureza-financeira',
              backend_config: [
                {
                  url: '/natureza_financeiras',
                  method: 'POST'
                }
              ],
              precedence: 4
            },
            {
              label: 'Centro de resultado',
              isSubMenu: false,
              routerLink: ['/centro_resultados'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-centro-resultado',
              backend_config: [
                {
                  url: '/centro_resultados',
                  method: 'POST'
                }
              ],
              precedence: 5
            },
            {
              label: 'Instituições financeiras',
              isSubMenu: false,
              routerLink: ['/instituicoes_financeiras'],
              icon: 'pi pi-fw pi-building',
              idElement: 'menu-instituicao',
              backend_config: [
                {
                  url: '/instituicao_pagamentos',
                  method: 'GET'
                }
              ],
              precedence: 6
            },
            // {
            //   label: 'Contas DRE',
            //   isSubMenu: false,
            //   routerLink: ['/conta_dre'],
            //   icon: 'pi pi-fw pi-money-bill',
            //   idElement: 'menu-conta-dre',
            //   backend_config: [
            //     {
            //       url: '/conta_dres',
            //       method: 'POST'
            //     }
            //   ],
            //   precedence: 7
            // }
          ],
          idElement: 'menu-config-financeiro'
        },
        matchBackendRoutes: [
          {
            url: '/forma_pagamentos',
            method: 'POST'
          },
          {
            url: '/condicao_pagamentos',
            method: 'POST'
          },
          {
            url: '/portadores/<id>/ajuste_saldo',
            method: 'PUT'
          },
          {
            url: '/centro_resultados',
            method: 'POST'
          },
          {
            url: '/natureza_financeiras',
            method: 'POST'
          },
          {
            url: '/instituicao_pagamentos',
            method: 'GET'
          },
          {
            url: '/conta_dres',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Produção',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-hammer-wrench',
          items: [
            {
              label: 'Peças',
              isSubMenu: false,
              routerLink: ['/pecas'],
              icon: 'pi pi-fw pi-box',
              idElement: 'menu-pecas',
              backend_config: [
                {
                  url: '/pecas',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Modelos',
              isSubMenu: false,
              routerLink: ['/modelos'],
              icon: 'pi pi-fw pi-box',
              idElement: 'menu-modelos',
              backend_config: [
                {
                  method: 'POST',
                  url: '/modelos'
                }
              ],
              precedence: 7
            },
            {
              label: 'Categoria de serviços',
              isSubMenu: false,
              routerLink: ['/categoria_servicos'],
              icon: 'mdi mdi-shape-outline',
              idElement: 'menu-categoria-servico',
              backend_config: [
                {
                  method: 'POST',
                  url: '/categoria_servicos'
                }
              ],
              precedence: 2
            },
            {
              label: 'Prioridades',
              isSubMenu: false,
              routerLink: ['/prioridades'],
              icon: 'mdi mdi-shape-outline',
              idElement: 'menu-prioridades',
              backend_config: [
                {
                  method: 'POST',
                  url: '/prioridades'
                }
              ],
              precedence: 2
            },
            {
              label: 'Níveis',
              isSubMenu: false,
              routerLink: ['/niveis'],
              icon: 'mdi mdi-shape-outline',
              idElement: 'menu-nivel',
              backend_config: [
                {
                  method: 'POST',
                  url: '/niveis'
                }
              ],
              precedence: 2
            },
            {
              label: 'Linha de montagem',
              isSubMenu: false,
              routerLink: ['/linha_montagem'],
              icon: 'mdi mdi-sitemap-outline',
              idElement: 'menu-linha-montagem',
              backend_config: [
                {
                  method: 'POST',
                  url: '/linha_producaos'
                }
              ],
              precedence: 4
            },
            {
              label: 'Serviços',
              isSubMenu: false,
              routerLink: ['/servicos'],
              icon: 'pi pi-fw pi-wrench',
              idElement: 'menu-servicos',
              backend_config: [
                {
                  method: 'POST',
                  url: '/servicos'
                }
              ],
              precedence: 3
            },
            {
              label: 'Etapas',
              isSubMenu: false,
              routerLink: ['/etapas'],
              icon: 'pi pi-fw pi-wrench',
              idElement: 'menu-etapas',
              backend_config: [
                {
                  method: 'POST',
                  url: '/etapas'
                }
              ],
              precedence: 5
            },
            {
              label: 'Processos',
              isSubMenu: false,
              routerLink: ['/processos'],
              icon: 'pi pi-fw pi-wrench',
              idElement: 'menu-processos',
              backend_config: [
                {
                  method: 'POST',
                  url: '/processos'
                }
              ],
              precedence: 6
            },
            {
              label: 'Tipo de erro de produção',
              isSubMenu: false,
              routerLink: ['/tipo_erro_producao'],
              icon: 'pi pi-fw pi-times-circle',
              idElement: 'menu-processos',
              backend_config: [
                {
                  method: 'POST',
                  url: '/tipo_erros'
                }
              ],
              precedence: 7
            }
          ],
          idElement: 'menu-config-producao'
        },
        matchBackendRoutes: [
          {
            url: '/pecas',
            method: 'POST'
          },
          {
            method: 'POST',
            url: '/modelos'
          },
          {
            method: 'POST',
            url: '/categoria_servicos'
          },
          {
            method: 'POST',
            url: '/linha_producaos'
          },
          {
            method: 'POST',
            url: '/servicos'
          },
          {
            method: 'POST',
            url: '/etapas'
          },
          {
            method: 'POST',
            url: '/processos'
          },
          {
            method: 'POST',
            url: '/tipo_erros'
          }
        ]
      },
      {
        menuItem: {
          icon: 'mdi mdi-truck-delivery-outline',
          label: 'Expedição',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-config-expedicao',
          items: [
            {
              label: 'Gerar expedição',
              isSubMenu: false,
              routerLink: ['/gerar_expedicao'],
              icon: 'mdi mdi-notebook-plus-outline',
              idElement: 'menu-gerar-expedição',
              backend_config: [
                {
                  method: 'POST',
                  url: '/expedicoes'
                }
              ],
              precedence: 1
            },
            {
              icon: 'mdi mdi-gas-station-outline',
              isSubMenu: false,
              label: 'Combustível',
              routerLink: ['/combustivel'],
              idElement: 'menu-combustivel',
              backend_config: [
                {
                  method: 'GET',
                  url: '/combustiveis'
                }
              ],
              precedence: 2
            },
            {
              icon: 'mdi mdi-marker-check',
              isSubMenu: false,
              label: 'Marca',
              routerLink: ['/marca'],
              idElement: 'menu-marca',
              backend_config: [
                {
                  method: 'GET',
                  url: '/marcas'
                }
              ],
              precedence: 3
            },
            {
              icon: 'mdi mdi-mailbox-outline',
              isSubMenu: false,
              label: 'Tipo de serviço correios',
              routerLink: ['/tipos_servicos_correios'],
              idElement: 'menu-tipo-correios',
              backend_config: [
                {
                  method: 'GET',
                  url: '/tipos_servicos_correios'
                }
              ],
              precedence: 4
            },
            {
              icon: 'mdi mdi-car-key',
              isSubMenu: false,
              label: 'Proprietário do veículo',
              routerLink: ['/proprietario_veiculo'],
              idElement: 'menu-proprietario-veiculo',
              backend_config: [
                {
                  method: 'GET',
                  url: '/proprietario_veiculos'
                }
              ],
              precedence: 5
            },
            {
              label: 'Modelo do transporte',
              isSubMenu: false,
              routerLink: ['/modelo_transporte'],
              icon: 'mdi mdi-car-outline',
              idElement: 'menu-proprietario-veiculo',
              backend_config: [
                {
                  method: 'GET',
                  url: '/modelo_veiculos'
                }
              ],
              precedence: 6
            },
            {
              label: 'Motorista',
              isSubMenu: false,
              routerLink: ['/motorista'],
              icon: 'mdi mdi-card-account-details-outline',
              idElement: 'menu-motorista',
              backend_config: [
                {
                  method: 'GET',
                  url: '/motoristas'
                }
              ],
              precedence: 7
            },
            {
              label: 'Veículo',
              isSubMenu: false,
              routerLink: ['/veiculo'],
              icon: 'mdi mdi-car',
              idElement: 'menu-veiculo',
              backend_config: [
                {
                  method: 'GET',
                  url: '/veiculos'
                }
              ],
              precedence: 8
            }
          ]
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/combustiveis'
          },
          {
            method: 'GET',
            url: '/marcas'
          },
          {
            method: 'GET',
            url: '/tipos_servicos_correios'
          },
          {
            method: 'GET',
            url: '/proprietario_veiculos'
          },
          {
            method: 'GET',
            url: '/modelo_veiculos'
          },
          {
            method: 'GET',
            url: '/motoristas'
          },
          {
            method: 'GET',
            url: '/veiculos'
          },
          {
            method: 'POST',
            url: '/expedicoes'
          }
        ]
      },
      {
        menuItem: {
          label: 'Vendas',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-cart-outline',
          items: [
            {
              label: 'Terminais',
              isSubMenu: false,
              routerLink: ['/terminais'],
              icon: 'pi pi-fw pi-desktop',
              idElement: 'menu-terminal',
              backend_config: [
                {
                  url: '/terminais',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Tabela de preço da fábrica',
              isSubMenu: false,
              routerLink: ['/tabela_preco_fabricas'],
              icon: 'mdi mdi-file-table-box-multiple-outline',
              idElement: 'menu-tabela-preco-fabrica',
              backend_config: [
                {
                  method: 'POST',
                  url: '/tabela_preco_fabricas'
                }
              ],
              precedence: 2
            }
          ],
          idElement: 'menu-config-vendas'
        },
        matchBackendRoutes: [
          {
            url: '/terminais',
            method: 'POST'
          },
          {
            method: 'POST',
            url: '/tabela_preco_fabricas'
          }
        ]
      },
      {
        menuItem: {
          label: 'Integrações',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-sitemap',
          items: [
            {
              label: 'Click massa',
              isSubMenu: false,
              routerLink: ['/integracoes/click_massa'],
              icon: 'pi pi-fw pi-phone',
              idElement: 'menu-click-massa-config',
              backend_config: [
                {
                  url: '/click_massa_clientes/<id>',
                  method: 'GET'
                }
              ],
              precedence: 1
            }
          ],
          idElement: 'menu-config-vendas'
        },
        matchBackendRoutes: [
          {
            url: '/click_massa_clientes/<id>',
            method: 'GET'
          }
        ]
      }
    ];
    if (this.tokenService.getDomain().name !== 'default')
      subMenuBuild.push({
        menuItem: {
          label: 'Empresa',
          isSubMenu: true,
          routerLink: null,
          icon: 'pi pi-fw pi-building',
          items: [
            {
              label: 'Dados da empresa',
              icon: 'pi pi-fw pi-building',
              isSubMenu: false,
              routerLink: ['/dados-empresa/editar'],
              idElement: 'menu-dados-empresa',
              backend_config: [
                {
                  url: '/domains/<id>',
                  method: 'PUT'
                }
              ],
              precedence: 1
            },
            {
              label: 'Configurações da empresa',
              icon: 'pi pi-fw pi-briefcase',
              isSubMenu: false,
              routerLink: ['/dados-empresa/settings'],
              idElement: 'menu-config-empresa',
              backend_config: [
                {
                  url: '/domains/<id>/settings',
                  method: 'PUT'
                }
              ],
              precedence: 2
            }
          ],
          idElement: 'menu-config-empresa'
        },
        matchBackendRoutes: [
          {
            url: '/domains/<id>',
            method: 'PUT'
          },
          {
            url: '/domains/<id>/settings',
            method: 'PUT'
          }
        ]
      });

    submenu = filterGrantSubMenuItens(routes, subMenuBuild);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Configurações',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        icon: 'pi pi-fw pi-cog',
        idElement: 'menu-config'
      };
    return menu;
  }

  /**
   * Gera o menu do módulo de relatórios
   * @param routes Rotas permitidas ao usuário
   */
  createMenuVendas(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];
    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Pedido de venda',
          isSubMenu: false,
          routerLink: ['/pedido_venda'],
          icon: 'pi pi-fw pi-shopping-cart',
          idElement: 'menu-pedido-venda',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'PUT',
            url: '/pedido_vendas/<id>'
          }
        ]
      },
      {
        menuItem: {
          label: 'Ordem de serviço',
          isSubMenu: false,
          routerLink: ['/ordem_de_servico'],
          icon: 'pi pi-fw pi-wrench',
          idElement: 'menu-ordem-servico',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'PUT',
            url: '/ordens_servico/<id>'
          }
        ]
      },
      {
        menuItem: {
          label: 'Caixa',
          isSubMenu: false,
          routerLink: ['/pdv'],
          precedence: 3,
          icon: 'pi pi-fw pi-desktop',
          idElement: 'menu-pdv'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/cupons'
          }
        ]
      },
      {
        menuItem: {
          label: 'Registros dos Caixas',
          isSubMenu: false,
          precedence: 4,
          routerLink: ['/registros_caixa'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-registros-caixa'
        },
        matchBackendRoutes: [
          {
            method: 'PUT',
            url: '/caixas/<id>/conferir_caixa'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Vendas',
        icon: 'mdi mdi-cart-outline',
        routerLink: null,
        items: submenu,
        idElement: 'menu-vendas'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de financeiro
   * @param routes Rotas permitidas ao usuário
   */
  createMenuFinanceiro(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];
    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Contas à receber',
          isSubMenu: false,
          routerLink: ['/contas-receber'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-conta-receber',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_recebers'
          }
        ]
      },
      {
        menuItem: {
          label: 'Contas à pagar',
          isSubMenu: false,
          routerLink: ['/contas-pagar'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-contapagar',
          backend_url_route: '/conta_pagars',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_pagars'
          }
        ]
      },
      {
        menuItem: {
          label: 'Movimentação financeira',
          isSubMenu: false,
          routerLink: ['/movimentacao_financeira'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-movimentacao-financeira',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/movimentacao_financeiras'
          }
        ]
      },
      {
        menuItem: {
          label: 'Correção de custos do pedido',
          isSubMenu: false,
          routerLink: ['/correcao-custo-pedidos'],
          icon: 'pi pi-fw pi-calculator',
          idElement: 'menu-correcao-custo',
          precedence: 5
        },
        matchBackendRoutes: [
          {
            method: 'PUT',
            url: '/pedidos/<id>/corrigir_custo'
          }
        ]
      },
      {
        menuItem: {
          label: 'Estorno',
          isSubMenu: false,
          routerLink: ['/estorno'],
          icon: 'mdi mdi-cash-refund',
          idElement: 'menu-estorno',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/estornos'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Financeiro',
        icon: 'mdi mdi-currency-brl',
        routerLink: null,
        items: submenu,
        idElement: 'menu-financeiro'
      };

    return menu;
  }

  /**
   * Gera o menu de orcamentos
   * @param routes
   */
  createMenuOrcamento(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Gerar orçamento',
          routerLink: ['/orcamentos'],
          icon: 'mdi mdi-receipt-text-edit-outline',
          idElement: 'menu-orcamentos',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/orcamentos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Controle de orçamentos',
          routerLink: ['/controle_orcamentos'],
          icon: 'mdi mdi-receipt-text-clock-outline',
          idElement: 'menu-controle-orcamentos',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'DELETE',
            url: '/orcamentos/<id>'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        label: 'Orçamentos',
        icon: 'mdi mdi-receipt-text-outline',
        routerLink: null,
        items: submenu,
        idElement: 'menu-principal-pedidos-producao'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de depósitos
   * @param routes Rotas permitidas ao usuário
   */
  createDepositoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Cadastro depósito',
          routerLink: ['/depositos'],
          idElement: 'menu-deposito',
          icon: 'mdi mdi-store-plus-outline',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pre_depositos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada',
          routerLink: ['/entrada_deposito'],
          icon: 'mdi mdi-archive-arrow-up-outline',
          idElement: 'menu-entrada-depositos',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/ree_depositos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Saida',
          routerLink: ['/saida_deposito'],
          icon: 'mdi mdi-archive-arrow-down-outline',
          idElement: 'menu-saida-depositos',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/rse_depositos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Transferência entre depósitos',
          routerLink: ['/transferencia_deposito'],
          icon: 'mdi mdi-bank-transfer',
          idElement: 'menu-transferencia-deposito',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/transf_depositos'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        icon: 'mdi mdi-store-marker-outline',
        label: 'Depósito',
        routerLink: null,
        items: submenu,
        idElement: 'menu-depositos'
      };

    return menu;
  }
}
